const ID_TOKEN_KEY = 'token';
const USER_PROFILE_KEY = 'userProfile';

export const getToken = () => {
  if (window.localStorage.getItem(ID_TOKEN_KEY) === null) return '';
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getHeaders = () => {
  let token = getToken();
  return {
    'x-access-token': token,
  };
};

export const getCurrentSchool = () => {
  let { school } = getUserProfile();
  return school;
};

export const getUserProfile = () => {
  if (window.localStorage.getItem(USER_PROFILE_KEY) === null) return '';
  const userString = window.localStorage.getItem(USER_PROFILE_KEY);
  return JSON.parse(userString);
};

export const saveToken = (token) => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveUserProfile = (profile) => {
  window.localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(profile));
};

export const saveSchool = (school) => {
  let user = getUserProfile();
  user.school = school;
  window.localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(user));
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(USER_PROFILE_KEY);
};

export default {
  getToken,
  saveToken,
  destroyToken,
  saveUserProfile,
  saveSchool,
  getUserProfile,
  getHeaders,
  getCurrentSchool,
};
